
import {Link} from "react-router-dom";
import Icon from "../../components/icon";

const QuickLinks = (props) => {
    return (
        <div className="quick-links">
            <div className="mb-3 d-block">
                <h6>Quick Links</h6>
                <p>Get easy access from here</p>
            </div>

            <ul className="stripped">
                <li><Link to="/emails/new"><Icon name="email"/> Create Email</Link></li>
                <li><Link to="/sms/new"><Icon name="sms"/> Create Sms</Link></li>
                <li><Link to="/landings/new"><Icon name="landing"/> Create Landing</Link></li>
                <li><Link to="/journeys/new"><Icon name="journey"/> Create Journey</Link></li>
                <li><Link to="/users/new"><Icon name="user"/> Create User</Link></li>
            </ul>
        </div>
    )
}

export default QuickLinks;